import {useEffect, useState} from 'react';
import {HttpError} from '../../../../../common/hooks/ApiClient';
import useShootForgotCode from '../../hooks/useShootForgotCode';
import {UseOTP} from './Types';

const otpLength = 6;

const useOTP = ({email, onValidate}: UseOTP) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | undefined>('');
	const [resendSeconds, setResendSeconds] = useState(120);
	const {shoot, isLoading: isResending} = useShootForgotCode();

	useEffect(() => {
		const interval = setInterval(() => setResendSeconds((current) => current - 1), 1000);

		return () => clearInterval(interval);
	}, []);

	const validate = async (code: string) => {
		setLoading(true);
		try {
			await onValidate(code);
		} catch (e) {
			if (e instanceof HttpError) {
				setError(e.message);
			}
		} finally {
			setLoading(false);
		}
	};

	const canResend = !isResending && resendSeconds <= 0 && email;

	const resend = async () => {
		if (!canResend) return;
		try {
			await shoot(email);
			setResendSeconds(120);
		} catch (e) {
			if (e instanceof HttpError) {
				setError(e.message);
			}
		}
	};

	return {
		otpLength,
		loading,
		validate,
		error,
		resend: {
			resend,
			seconds: resendSeconds,
			canResend,
			isResending,
			showTimer: !canResend && !isResending,
		},
	};
};

export default useOTP;
